<template>
  <div v-if="user">
    <div class="register-top">
      <div>
        <h2 class="mb-4">
          {{ $t('register.welcome.title') }}
          <span style="color: #F07B83;">{{ user.firstname }}</span> :)
        </h2>
        <p>{{ $t('register.welcome.body') }}</p>
      </div>
    </div>
    <div class="register-bottom">
      <register-base-button
        :to="{ name: 'Identity' }"
        gradient="linear-gradient(90deg, #FF757E 0%, #FF32B2 100%)"
      >
        {{ $t('register.welcome.start') }}
      </register-base-button>
      <br />
      <router-link :to="{ name: 'NotMe' }" class="register-link">
        {{ $t('register.welcome.not_me') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import RegisterBaseButton from '@/components/RegisterBaseButton'

export default {
  computed: {
    user() {
      return this.$store.getters['user/get']
    }
  },
  components: {
    RegisterBaseButton
  }
}
</script>
